/**
 * Keeps the variant picker in sync with the product media gallery.
 *
 * When a shopper swipes or clicks the gallery's next/previous arrows to a
 * different image, and that image is tied to a specific option value (e.g. a
 * design/style), the matching option is selected in the variant picker too.
 *
 * Listens globally for the theme's `slideshow:select` event (dispatched by
 * every slideshow on the page) and only acts on ones that both:
 *   - were triggered by the shopper (event.detail.userInitiated), so the
 *     gallery's own variant-driven re-selection doesn't loop back here, and
 *   - occur inside a media gallery that shipped a media-to-option-value map.
 */
if (!window.__mediaGalleryVariantSyncInit) {
  window.__mediaGalleryVariantSyncInit = true;

  document.addEventListener('slideshow:select', (event) => {
    const detail = /** @type {{ slide?: Element, userInitiated?: boolean }} */ (event).detail;
    if (!detail?.userInitiated || !(detail.slide instanceof Element)) return;

    const mediaGallery = detail.slide.closest('media-gallery');
    if (!mediaGallery) return;

    const mediaIdElement = detail.slide.querySelector('[data-media-id]');
    const mediaId = mediaIdElement instanceof HTMLElement ? mediaIdElement.dataset.mediaId : undefined;
    if (!mediaId) return;

    const mapScript = mediaGallery.querySelector('script[type="application/json"][data-media-variant-map]');
    if (!mapScript?.textContent) return;

    /** @type {Record<string, string>} */
    let mediaVariantMap;
    try {
      mediaVariantMap = JSON.parse(mapScript.textContent);
    } catch {
      return;
    }

    const optionValue = mediaVariantMap[mediaId];
    if (!optionValue) return;

    const section = mediaGallery.closest('.shopify-section');
    const variantPicker = section?.querySelector('variant-picker');
    const fieldset = variantPicker?.querySelector('fieldset');
    if (!fieldset) return;

    const input = /** @type {HTMLInputElement | undefined} */ (
      Array.from(fieldset.querySelectorAll('input')).find((el) => el instanceof HTMLInputElement && el.value === optionValue)
    );
    if (!input || input.checked) return;

    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}
